import store from '../store';

export const sortDep = (a, b) => {
	if (a.lastName > b.lastName) return 1;
	if (a.lastName < b.lastName) return -1;
	if (a.lastName === b.lastName) {
		if (a.firstName > b.firstName) return 1;
		if (a.firstName < b.firstName) return -1;
	}
	return 0;
};

export default async (filter) => {
	const convs = await store.model.Convocation.find({ where: { current: true } });
	const conv = convs.length > 0 ? convs[0] : null;
	const where = {
		and: [
			{ convocationId: conv.id },
			{ endDate: null },
		]
	};
/*
	if (filter && filter.where) {
		where.and.push(filter.where);
	}
	let rest = {};
	if (filter) {
		const { where: _where, ...rest1 } = filter;
		rest = {...rest1};
	}
*/
	if (conv) {
		const depConvs = await store.model.DeputyConvocation.find({
			where,
			include: ['deputy'],
			// ...rest
		});
		return depConvs.filter(depConv => !!depConv.deputy).map(depConv => depConv.endDate === null && depConv.deputy).sort(sortDep).filter(d=> d);
	}
	console.warn('No deputies! Current convocation:', conv);
	return [];
}
